module.exports = __webpack_public_path__ + "img/PXL_20230526_085434898.c679ca69.jpg";